import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8aa5a2fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_s"
};
import chatting from "@/components/chatting/index.vue";
import TagItem from "@/components/tag-item/index.vue";
import organization from "@/components/organization/index.vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'postoperativecare',
  setup(__props) {
    const types = ref(1);
    const tag_list = ref([{
      id: 1,
      name: "客户"
    }, {
      id: 2,
      name: "员工"
    }, {
      id: 3,
      name: "群聊"
    }]);
    const cha_id = ref("");
    const from = ref('');
    const set_from = id => {
      from.value = id;
    };
    const set_chart = item => {
      types.value = 1;
      cha_id.value = item.md5;
      item_chats.value = item;
    };
    const item_chats = ref('');
    const set_chart2 = item => {
      types.value = 2;
      cha_id.value = item.chat_id;
      item_chats.value = item;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(organization, {
        onSet_from: set_from
      }), _createVNode(TagItem, {
        class: "margin-l-20",
        from: from.value,
        tag_list: tag_list.value,
        onSet_chart: set_chart,
        onSet_chart2: set_chart2
      }, null, 8, ["from", "tag_list"]), _createVNode(chatting, {
        class: "margin-l-20",
        from: from.value,
        cha_id: cha_id.value,
        item_chats: item_chats.value,
        types: types.value
      }, null, 8, ["from", "cha_id", "item_chats", "types"])]);
    };
  }
});